var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretDown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6925 8.16812L10.4425 14.4181C10.3845 14.4762 10.3156 14.5223 10.2397 14.5538C10.1638 14.5852 10.0825 14.6014 10.0003 14.6014C9.91821 14.6014 9.83688 14.5852 9.76101 14.5538C9.68514 14.5223 9.61621 14.4762 9.55816 14.4181L3.30816 8.16812C3.19088 8.05085 3.125 7.89179 3.125 7.72593C3.125 7.56008 3.19088 7.40102 3.30816 7.28375C3.42544 7.16647 3.5845 7.10059 3.75035 7.10059C3.9162 7.10059 4.07526 7.16647 4.19253 7.28375L10.0003 13.0923L15.8082 7.28375C15.8662 7.22568 15.9352 7.17961 16.011 7.14819C16.0869 7.11676 16.1682 7.10059 16.2503 7.10059C16.3325 7.10059 16.4138 7.11676 16.4897 7.14819C16.5655 7.17961 16.6345 7.22568 16.6925 7.28375C16.7506 7.34181 16.7967 7.41075 16.8281 7.48662C16.8595 7.56249 16.8757 7.64381 16.8757 7.72593C16.8757 7.80806 16.8595 7.88937 16.8281 7.96524C16.7967 8.04111 16.7506 8.11005 16.6925 8.16812Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDropdown);
export default __webpack_public_path__ + "static/media/icons-dropdown.76dd14550d62544dbec0d27a4e4315ce.svg";
export { ForwardRef as ReactComponent };